import { SendHorizontal, CalendarClock, BellRing, Trophy, AlertTriangle, ShieldQuestion, ShieldCheck } from "lucide-react";

const OPTIONS = [
  { id: "unsent", label: "Nog niet verzonden", icon: SendHorizontal, title: "Contacten met e-mail die nog geen mail kregen" },
  { id: "week", label: "Deze week verzonden", icon: CalendarClock, title: "Laatste mail verzonden in de afgelopen 7 dagen" },
  { id: "due", label: "Opvolging klaar", icon: BellRing, title: "Wachttijd voorbij: Mail 2 of Mail 3 kan nu verstuurd worden" },
  { id: "customers", label: "Klanten", icon: Trophy, title: "Alle clubs die klant zijn geworden" },
  { id: "perm_asked", label: "Toestemming gevraagd", icon: ShieldQuestion, title: "Toestemmingsmail verstuurd, nog geen antwoord" },
  { id: "perm_granted", label: "Toestemming gegeven", icon: ShieldCheck, title: "Mogen Mail 1–3 ontvangen" },
  { id: "failed", label: "Scrape mislukt", icon: AlertTriangle, title: "Website te traag of laadde niet bij de laatste diepe scrape" },
];

export const SentFilterBar = ({ value, onChange, counts }) => (
  <div data-testid="sent-filter-bar" className="inline-flex flex-wrap items-center gap-1 rounded-full border border-slate-300 bg-white p-1">
    {OPTIONS.map(({ id, label, icon: Icon, title }) => {
      const active = value === id || (id === "due" && (value === "due2" || value === "due3"));
      return (
        <button
          key={id}
          data-testid={`sent-filter-${id}`}
          title={title}
          onClick={() => onChange(active ? null : id)}
          className={`inline-flex items-center gap-1.5 rounded-full px-3 h-8 text-sm font-medium transition-colors ${
            active ? (id === "customers" ? "bg-amber-500 text-white" : "bg-[#FF4500] text-white") : id === "due" && counts[id] ? "text-[#FF4500] hover:bg-orange-50" : id === "customers" && counts[id] ? "text-amber-700 hover:bg-amber-50" : "text-slate-600 hover:bg-slate-100"
          }`}
        >
          <Icon className="w-3.5 h-3.5" strokeWidth={1.75} />
          {label} ({counts[id] || 0})
        </button>
      );
    })}
  </div>
);
